module.exports = __webpack_public_path__ + "e378ca3d9e91d95527d288540b9748b5.svg";